import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from './store/authStore'
import { Layout } from './components/Layout'
import { LoadingSpinner } from './components/LoadingSpinner'

// 页面组件 - 懒加载
const LandingPage = React.lazy(() => import('./pages/LandingPage'))
const LoginPage = React.lazy(() => import('./pages/auth/LoginPage'))
const ForgotPasswordPage = React.lazy(() => import('./pages/auth/ForgotPasswordPage'))
const ResetPasswordPage = React.lazy(() => import('./pages/auth/ResetPasswordPage'))
const RegisterPage = React.lazy(() => import('./pages/auth/NewRegisterPage'))
const AuthCallbackPage = React.lazy(() => import('./pages/AuthCallbackPage'))
const VerificationPendingPage = React.lazy(() => import('./pages/VerificationPendingPage'))
const VerifyEmailPage = React.lazy(() => import('./pages/auth/VerifyEmailPage'))
const PrivacyPolicyPage = React.lazy(() => import('./pages/PrivacyPolicyPage'))
const TermsOfServicePage = React.lazy(() => import('./pages/TermsOfServicePage'))
const StudentsPage = React.lazy(() => import('./pages/StudentsPage'))
const CalendarSchedulePage = React.lazy(() => import('./pages/CalendarSchedulePage'))
const MessagesPage = React.lazy(() => import('./pages/MessagesPage'))
const MaterialsPage = React.lazy(() => import('./pages/MaterialsPage'))
const SoftwareToolsPage = React.lazy(() => import('./pages/SoftwareToolsPage'))
const HelpPage = React.lazy(() => import('./pages/HelpPage'))
const EarningsPage = React.lazy(() => import('./pages/EarningsPage'))
const VideoSettingsPage = React.lazy(() => import('./pages/VideoSettingsPage'))
const ProfilePage = React.lazy(() => import('./pages/ProfilePage'))
const NotFoundPage = React.lazy(() => import('./pages/NotFoundPage'))

function App() {
  const { isAuthenticated, isLoading, user } = useAuthStore()

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <LoadingSpinner className="w-12 h-12 mx-auto mb-4" />
          <p className="text-gray-600">加载中...</p>
        </div>
      </div>
    )
  }

  return (
    <div className="layout-container">
      <React.Suspense fallback={
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
          <LoadingSpinner className="w-8 h-8" />
        </div>
      }>
        <Routes>
          {/* 认证路由 */}
          {!isAuthenticated ? (
            <>
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/auth/callback" element={<AuthCallbackPage />} />
              <Route path="/auth/verify" element={<VerifyEmailPage />} />
              <Route path="/verification-pending" element={<VerificationPendingPage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/terms-of-service" element={<TermsOfServicePage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </>
          ) : (
            <>
              {/* 已认证路由 */}
              <Route path="/" element={<Layout />}>
                <Route index element={<Navigate to="/calendar" replace />} />
                <Route path="calendar" element={<CalendarSchedulePage />} />
                <Route path="students" element={<StudentsPage />} />
                <Route path="messages" element={<MessagesPage />} />
                <Route path="materials" element={<MaterialsPage />} />
                <Route path="software-tools" element={<SoftwareToolsPage />} />
                <Route path="help" element={<HelpPage />} />
                <Route path="earnings" element={<EarningsPage />} />
                <Route path="video-settings" element={<VideoSettingsPage />} />
                <Route path="profile" element={<ProfilePage />} />
                <Route path="dashboard" element={<Navigate to="/calendar" replace />} />
                <Route path="schedule" element={<Navigate to="/calendar" replace />} />
                <Route path="login" element={<Navigate to="/calendar" replace />} />
                <Route path="register" element={<Navigate to="/calendar" replace />} />
                <Route path="forgot-password" element={<Navigate to="/calendar" replace />} />
                <Route path="*" element={<NotFoundPage />} />
              </Route>
            </>
          )}
        </Routes>
      </React.Suspense>
    </div>
  )
}

export default App